import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000', ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M4.19 2.69a1.5 1.5 0 011.06-.44h9a.75.75 0 01.53.22l5.25 5.25c.141.14.22.331.22.53v12a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V3.75c0-.398.158-.78.44-1.06zm9.75 1.06H5.25v16.5h13.5V8.56l-4.81-4.81z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M14.25 2.25A.75.75 0 0115 3v4.5h4.5a.75.75 0 010 1.5h-5.25a.75.75 0 01-.75-.75V3a.75.75 0 01.75-.75zM16.789 11.148a.75.75 0 010 1.061l-5.25 5.25a.75.75 0 01-1.06 0l-2.626-2.625a.75.75 0 111.06-1.06l2.095 2.094 4.72-4.72a.75.75 0 011.06 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
